$(function () {
  $(document).on('click', 
                 '.spice-spa-addon-product-wrapper .spice-spa-addon-left .spice-spa-addon-checkbox label .needsclick, '+
                 '.js-warranty-complementary-products li,' + 
                 '.t4s-form__product .t4s-swatch__item', 
                 function (e) {
                   console.log(e)
    setTimeout(updatePdpTotalPrice, 200)
  })
})

function updatePdpTotalPrice() {
  var total_price_wrapper = $('.pdp-total-price-wrapper');
  var compared_price_class = '.compared-price';
  var price_container = $('.t4s-product__info-container .t4s-product-price');
  var price = stringToNumber(price_container.find('ins').text());
  var compared_price = stringToNumber(price_container.find('del').text());
  var warranty_price = stringToNumber($('.js-warranty-complementary-products .grid__item.active .warranty-price').text());
  var addon_price = getAddonPrice()
 
  compared_price = math.add(compared_price, warranty_price, addon_price)
  if (price) {
    price = math.add(price, warranty_price, addon_price)
    total_price_wrapper.find('.price').text(numberToPrice(price)).end()
      .find(compared_price_class).text(numberToPrice(compared_price)).show();
  } else {
    total_price_wrapper.find('.price').text(numberToPrice(compared_price)).end()
      .find(compared_price_class).hide();
  }
}

function getAddonPrice() {
  var addon = $('.spice-spa-addon-product-wrapper [type=checkbox]:checked');
  var total = 0;
  
  if(addon && addon.length > 0){
    for(var i=0; i< addon.length; i++) {
      total += stringToNumber($(addon[i]).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-price-main').text())
    }
  }

  return total
}

function stringToNumber(str) {
  if(!str) return 0;
  var num = parseFloat(str.replace('$', 0).replace(',', ''));
  if(isNaN(num)) return 0;
  
  return num;
}

function numberToPrice(price_number) {
  if (typeof price_number !== 'number') return price_number
  
    return currency_symbol.replace('{{amount}}', price_number.toFixed(2))
}